import React, { useState } from 'react';

import { Grid } from 'core/components/library';

import {
    Select,
    DataGridPro as DataGrid,
    Text,
    Combo,
    Tag,
    Switch
} from 'core/components';

import * as helpers from 'core/helpers';
import * as enums from 'core/enums';
import * as icons from '../../../../../../core/icons';
import List from '../../../../../../store/List';
import { Chip, Divider } from '../../../../../../core/components/library';

const ComboMedidas = List(Combo, 'options', 'lstMedidas');
const ComboTipos = List(Combo, 'options', 'lstTiposLiquidacion');
const ComboEnvases = List(Combo, 'options', 'lstEnvases');
const ComboMunicipios = List(Combo, 'options', 'lstmunicipios');
const ComboCultivos = List(Combo, 'options', 'lstcultivos');

const cols = (name, row, index, editing, handleChange, refresh) => [
    {
        key: 'municipio',
        title: 'Municipio',
        align: 'left',
        //width: '20%',
        component: row && !row.tasa && (
            <ComboMunicipios
                fullWidth
                api='auxiliares/municipios/'
                name='municipio'
                nameKey='municipioId'
                variant='standard'
                Icon={icons.MunicipioIcon}
                value={row.municipio}
                onChange={
                    handleChange &&
                    (values => handleChange(values, name, index))
                }
                editing={editing}
                propertyValue='id'
                getOptionLabel={option => option.descripcion}
                searchKeys={['descripcion']}
            />
        )
    },
    {
        key: 'modoCultivo',
        title: 'Cultivo',
        align: 'left',
        //width: '20%',
        component: row && !row.tasa && (
            <ComboCultivos
                fullWidth
                api='auxiliares/modosCultivo/'
                name='modoCultivo'
                nameKey='modoCultivoId'
                variant='standard'
                value={row.modoCultivo}
                onChange={
                    handleChange &&
                    (values => handleChange(values, name, index))
                }
                editing={editing}
                propertyValue='id'
                getOptionLabel={option => option.descripcion}
                searchKeys={['descripcion']}
            />
        )
    },
    {
        key: 'envase',
        title: 'Envase',
        align: 'left',
        //width: '20%',
        component: row && !row.tasa && (
            <ComboEnvases
                fullWidth
                api='auxiliares/envases/'
                name='envase'
                nameKey='envaseId'
                variant='standard'
                Icon={icons.PackageIcon}
                value={row.envase}
                onChange={
                    handleChange &&
                    (values => handleChange(values, name, index))
                }
                editing={editing}
                propertyValue='id'
                getOptionLabel={option => option.descripcion}
                searchKeys={['descripcion']}
            />
        )
    },
    {
        key: 'resolucion',
        title: 'Resolución',
        align: 'left',
        //width: '15%',
        component: row && (
            <Select
                fullWidth
                variant='standard'
                name='resolucion'
                value={row.resolucion}
                onChange={
                    handleChange &&
                    (values => handleChange(values, name, index))
                }
                editing={editing}
                options={enums.resultsResolution}
            />
        )
    },
    {
        key: 'tasa',
        title: 'Tasa',
        align: 'center',
        width: '3%',
        component: row && (
            <Switch
                value={row.tasa}
                onChange={
                    handleChange &&
                    (values => handleChange(values, name, index))
                }
                name='tasa'
                //label='El importe es una tasa'
                editing={editing}
            />
        )
    },
    {
        key: 'medida',
        title: 'Und. Medida',
        align: 'left',
        //width: '20%',
        component: row && !row.tasa && (
            <ComboMedidas
                fullWidth
                margin='none'
                variant='standard'
                api='auxiliares/unidadesmedida/'
                name='medida'
                nameKey='medidaid'
                refresh={refresh}
                Icon={icons.MedicionIcon}
                value={row.medida}
                onChange={
                    handleChange &&
                    (values => handleChange(values, name, index))
                }
                editing={editing}
                propertyValue='id'
                getOptionLabel={option =>
                    `${option.id} (${option.descripcion})`
                }
            />
        )
    },
    {
        key: 'importe',
        title: 'Importe €',
        align: 'left',
        width: '10%',
        component: row && (
            <Text
                fullWidth
                editing={editing}
                name='importe'
                variant='standard'
                margin='none'
                type='d.4'
                value={row['importe']}
                onFocus={event => event.target.select()}
                onChange={
                    handleChange &&
                    (values => handleChange(values, name, index))
                }
            />
        )
    }
];

const Liquidaciones = props => {
    const { values, editing, adding, handleChange, refresh } = props;
    const [campaña, setCampaña] = useState(null);
    const [operacion, setOperacion] = useState(null);
    const [tipo, setTipo] = useState(null);

    return (
        <>
            <Grid container spacing={1}>
                <Grid item xs={2}>
                    <Select
                        fullWidth
                        name='campaña'
                        label='Campaña'
                        value={campaña}
                        onChange={data => setCampaña(data[0].value)}
                        editing={true}
                        options={enums.campañas}
                    />
                </Grid>
                <Grid item xs>
                    <ComboTipos
                        fullWidth
                        label={'Tipo de liquidación'}
                        api='tiposLiquidacion'
                        name='tipo'
                        nameKey='tipoid'
                        refresh={refresh}
                        Icon={icons.DefinicionIcon}
                        value={tipo}
                        onChange={data => setTipo(data[0].value.selected)}
                        editing={true}
                        propertyValue='id'
                        getOptionLabel={option =>
                            `[${option.id}]-${option.descripcion}`
                        }
                        searchKeys={['id', 'descripcion']}
                    />
                </Grid>
                <Grid item xs={2}>
                    {/*<Select
                        fullWidth
                        name='operacion'
                        label='Operación'
                        value={operacion}
                        onChange={data => setOperacion(data[0].value)}
                        editing={true}
                        options={enums.operationType}
                    />*/}
                </Grid>
            </Grid>
            <Grid container spacing={1}>
                <Grid item xs>
                    <Divider style={{ margin: '12px 12px 12px 12px' }}>
                        <Chip label={'Tabla de Precios'} />
                    </Divider>
                </Grid>
            </Grid>
            <Grid container spacing={1}>
                <Grid item xs>
                    <DataGrid
                        name='liquidaciones'
                        editing={editing}
                        rows={
                            values && values.liquidaciones
                                ? values.liquidaciones
                                : []
                        }
                        cols={(name, row, index) =>
                            cols(
                                name,
                                row,
                                index,
                                editing,
                                handleChange,
                                refresh
                            )
                        }
                        onAdd={name => {
                            handleChange(
                                {
                                    tipoLiquidacion: tipo,
                                    campaña: campaña,
                                    operacion: operacion,
                                    importe: (0).toFixed(2)
                                },
                                name
                            );
                        }}
                        onDelete={(name, index) =>
                            handleChange(undefined, name, (index + 1) * -1)
                        }
                        minHeight={350}
                        maxHeight={350}
                        filters={[
                            { key: 'campaña', value: campaña, property: null },
                            /*{
                                key: 'operacion',
                                value: operacion,
                                property: null
                            },*/
                            {
                                key: 'tipoLiquidacion',
                                value: tipo?.id,
                                property: 'id'
                            }
                        ]}
                    />
                </Grid>
            </Grid>
        </>
    );
};

export default Liquidaciones;
